import React from "react";
import { Container } from "@mantine/core";
import ReportView from "../ReportView";
import { ReportDefinition, SalonReport } from "../../../types/reports";
// The legacy detail page's own container (max width, centering, top
// padding), so a legacy report keeps exactly the layout it always had.
import legacyStyles from "../ReportsPage.module.css";

export interface LegacyReportBodyProps {
  salonId: string;
  definition: ReportDefinition;
  report: SalonReport;
  isDeleting: boolean;
  onReportUpdated: (report: SalonReport) => void;
  onDelete: () => void;
}

/**
 * Hosts a legacy report inside the Reports v2 shell by rendering the existing
 * ReportView exactly as the legacy detail page does — same props, the same
 * page container, on the app's default content background (the shell's main
 * column) — no behaviour or styling changes. Keyed by report id so switching reports in the sidebar
 * remounts it (ReportView seeds its view state from the saved report once).
 */
export default function LegacyReportBody({
  salonId,
  definition,
  report,
  isDeleting,
  onReportUpdated,
  onDelete,
}: LegacyReportBodyProps) {
  return (
    <Container fluid className={legacyStyles.container}>
      <ReportView
        key={report.id}
        salonId={salonId}
        definition={definition}
        report={report}
        isDeleting={isDeleting}
        onReportUpdated={onReportUpdated}
        onDelete={onDelete}
      />
    </Container>
  );
}
